import { __values } from "tslib";
import { OrderHeader } from './OrderHeader';
var orderLine = /** @class */ (function () {
    function orderLine() {
        this.amount = 0;
        this.appOrderId = 0;
        this.appOrderLineId = 0;
        this.blocked = false;
        this.collectionName = '';
        this.collectionSortCode = 0;
        this.colorBlocked = false;
        this.colorCode = '';
        this.colorName = '';
        this.deliveryCode = '';
        this.deliveryprintdescription = '';
        this.deliveryshiptmentdate = '';
        this.deliverysort = 0;
        this.delivreryshortdescription = '';
        this.description = '';
        this.description2 = '';
        this.itemId = '';
        this.linediscountpct = 0;
        this.lineNumber = 0;
        this.linediscountamount = 0;
        this.masterId = '';
        this.productCategory = '';
        this.productGroup = '';
        this.quantity = 0;
        this.quantityShipped = 0;
        this.sizeCode = '';
        this.sizeName = '';
        this.unitPrice = 0;
        this.unmodifiedNavQuantity = 0;
        this.vatPct = 0;
        this.topCollection = '';
        this.organic = false;
        this.ecovero = false;
        this.gots = '';
        this.recycled = false;
        this.seasonCode = '';
        this.oekotex = '';
        this.subCategories = [];
        this.orderLines = [];
        this.whp = 0;
        this.msrp = 0;
        this.totalDisp = 0;
        this.ocsno = '';
        this.grsno = '';
        this.ocsblended = '';
        this.discontinued = false;
        this.orderType = '';
        this.fabricComposition = '';
        this.styleComment = '';
        this.colorComment = '';
        this.styleNote = '';
        this.colorNote = '';
    }
    orderLine.buildFromB2B = function (data) {
        var line = new orderLine();
        line.amount = data.amount;
        line.appOrderId = data.appOrderId;
        line.appOrderLineId = data.appOrderLineId;
        line.blocked = data.blocked;
        line.collectionName = data.collection;
        line.collectionSortCode = data.collectionsort;
        line.colorBlocked = data.colorBlocked;
        line.colorCode = data.colorcode;
        line.colorName = data.colorname;
        line.deliveryCode = data.deliveryCode;
        line.deliveryprintdescription = data.deliveryprintdescription;
        line.deliveryshiptmentdate = data.deliveryshiptmentdate;
        line.deliverysort = data.deliverysort;
        line.delivreryshortdescription = data.delivreryshortdescription;
        line.description = data.description;
        line.discontinued = data.discontinued || false;
        line.gots = data.gots;
        line.oekotex = data.oekoTex;
        line.organic = data.organic;
        line.ecovero = data.ecovero;
        line.recycled = data.recycled;
        line.description2 = data.description2;
        line.itemId = data.itemId;
        line.linediscountpct = data.lineDiscountPct;
        line.lineNumber = data.lineNumber;
        line.linediscountamount = data.linediscountAmount;
        line.masterId = data.masterid;
        line.productCategory = data.productcategory;
        line.productGroup = data.productgroup;
        line.quantity = data.quantity;
        line.quantityShipped = data.quantityShipped;
        line.sizeCode = data.sizecode;
        line.sizeName = data.sizename;
        line.unitPrice = data.unitPrice;
        line.unmodifiedNavQuantity = data.unmodifiedNavQuantity;
        line.vatPct = data.vatPct;
        line.seasonCode = data.seasoncode;
        line.ocsno = data.ocsno || '';
        line.grsno = data.grsno || '';
        line.ocsblended = data.ocsblended || '';
        line.deliveryWindow = {
            print: data.deliveryprintdescription,
            sort: data.deliverysort,
            window: data.deliveryCode,
            shipmentDate: data.deliveryshiptmentdate,
            label: data.deliveryprintdescription,
            originalWindow: data.deliveryCode
        };
        return line;
    };
    orderLine.buildFromSalesbook = function (data) {
        var line = new orderLine();
        line.amount = data.amount;
        line.appOrderId = data.apporderid;
        line.appOrderLineId = data.apporderlineid;
        line.blocked = data.blocked;
        line.collectionName = data.collection;
        line.collectionSortCode = data.collectionsort;
        line.colorBlocked = data.colorblocked;
        line.colorCode = data.colorcode;
        line.colorName = data.colorname;
        line.deliveryCode = data.deliverycode;
        line.deliveryprintdescription = data.deliveryprintdescription;
        line.deliveryshiptmentdate = data.deliveryshiptmentdate;
        line.deliverysort = data.deliverysort;
        line.delivreryshortdescription = data.delivreryshortdescription;
        line.description = data.description;
        line.discontinued = data.discontinued || false;
        line.gots = data.gots;
        line.oekotex = data.oekotex;
        line.organic = data.organic;
        line.ecovero = data.ecovero;
        line.recycled = data.recycled;
        line.description2 = data.description2;
        line.itemId = data.itemid;
        line.linediscountpct = data.linediscountpct;
        line.lineNumber = data.apporderlineid;
        line.linediscountamount = data.linediscountamount;
        line.masterId = data.masterid;
        line.productCategory = data.productcategory;
        line.productGroup = data.productgroup;
        line.quantity = data.quantity;
        line.quantityShipped = data.quantityshipped;
        line.sizeCode = data.sizecode;
        line.sizeName = data.sizename;
        line.unitPrice = data.unitprice;
        line.unmodifiedNavQuantity = data.unmodifiedNavQuantity;
        line.vatPct = data.vatpct;
        line.seasonCode = data.seasoncode;
        line.ocsno = data.ocsno || '';
        line.grsno = data.grsno || '';
        line.ocsblended = data.ocsblended || '';
        line.deliveryWindow = {
            print: data.deliveryprintdescription,
            sort: data.deliverysort,
            window: data.deliverycode,
            shipmentDate: data.deliveryshiptmentdate,
            label: data.deliveryprintdescription,
            originalWindow: data.deliverycode
        };
        return line;
    };
    return orderLine;
}());
export { orderLine };
export function mapOrderlinesFromSalesbook(data) {
    var e_1, _a;
    var mapped = [];
    try {
        for (var data_1 = __values(data), data_1_1 = data_1.next(); !data_1_1.done; data_1_1 = data_1.next()) {
            var line = data_1_1.value;
            var newLine = orderLine.buildFromSalesbook(line);
            mapped.push(newLine);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (data_1_1 && !data_1_1.done && (_a = data_1.return)) _a.call(data_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return mapped;
}
export function mapOrderlinesFromB2B(data) {
    var e_2, _a;
    var mapped = [];
    try {
        for (var data_2 = __values(data), data_2_1 = data_2.next(); !data_2_1.done; data_2_1 = data_2.next()) {
            var line = data_2_1.value;
            var newLine = orderLine.buildFromB2B(line);
            mapped.push(newLine);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (data_2_1 && !data_2_1.done && (_a = data_2.return)) _a.call(data_2);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return mapped;
}
var Order = /** @class */ (function () {
    function Order() {
        this.orderLines = [];
        this.orderTotals = { amount: 0, noOfItems: 0 };
        this.isCurrentOrderType = false;
    }
    Order.buildFromB2B = function (data) {
        var order = new Order();
        order.orderLines = mapOrderlinesFromB2B(data.orderLines);
        order.orderTotals = {
            amount: data.orderTotals.amount,
            noOfItems: data.orderTotals.noOfItems,
        };
        order.orderHeader = OrderHeader.buildFromB2B(data.orderheader);
        return order;
    };
    Order.buildFromSalesbook = function (data) {
        var order = new Order();
        order.orderLines = mapOrderlinesFromSalesbook(data && data.orderlines ? data.orderlines : []);
        order.orderTotals = {
            amount: data.ordertotals.amount,
            noOfItems: data.ordertotals.noofitems,
        };
        order.orderHeader = OrderHeader.buildFromSalesbook(data.order);
        return order;
    };
    return Order;
}());
export { Order };
//# sourceMappingURL=Order.js.map